import React, { ReactElement, useState, useEffect, useRef } from 'react';

import Announcement from '~/components/Announcement';
import Gap from '~/components/flow/Gap';

interface AudioPlayerProps {
  visible: boolean;
  url: string;
}

function AudioPlayer({ visible, url }: AudioPlayerProps): ReactElement {
  const [errorText, setErrorText] = useState('');
  const controlsList = 'nodownload nofullscreen noremoteplayback';
  const audioRef = useRef<HTMLAudioElement>(null);

  // Handlers
  const onError = () => {
    setErrorText('Could not load audio, please try again later');
  };

  // Styling
  const audioStyle = {
    width: '100%',
  };

  useEffect(() => {
    if (!visible && audioRef.current) audioRef.current.pause();
  }, [visible]);

  return (
    <div>
      {errorText && (
        <>
          <Announcement>{errorText}</Announcement>
          <Gap />
        </>
      )}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio
        src={url}
        controls
        controlsList={controlsList}
        onError={onError}
        style={audioStyle}
        ref={audioRef}
      />
    </div>
  );
}

export default AudioPlayer;
